import {
    AnalyticsActionTypes,
    AnalyticsState,
    FETCH_REPORT_CONFIGURATION_FAIL,
    FETCH_REPORT_CONFIGURATION_REQUEST,
    FETCH_REPORT_CONFIGURATION_SUCCESS,
    RESET_ANALYTICS_STATE,
} from './types';

const initialState = {
    reportConfiguration: {
        report: {},
        excludedPages: [],
    },
    isFailed: false,
    isLoading: false,
    organizationId: ''
};

const reducer = (state: AnalyticsState = initialState, action: AnalyticsActionTypes): AnalyticsState => {
    switch (action.type) {
        case FETCH_REPORT_CONFIGURATION_REQUEST:
            return {
                ...state,
                isFailed: false,
                isLoading: true,
                organizationId: action.payload
            };

        case FETCH_REPORT_CONFIGURATION_SUCCESS:
            return {
                ...state,
                reportConfiguration: action.payload,
                isLoading: false,
                isFailed: false,
            };

        case FETCH_REPORT_CONFIGURATION_FAIL:
            return {
                ...state,
                isLoading: false,
                isFailed: true,
            };
        case RESET_ANALYTICS_STATE:
            return initialState;

        default:
            return state;
    }
};

export default reducer;
